import React from 'react';
export default props => {
  return (
    <div>
      {props.company._id}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/companies/Details.jsx